import { Container, Grid } from "@mui/material";
import React from "react";
import { P, SectionHeading, SectionWrapper } from "../../Styles/style";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import footerman from "../../../assets/images/footerman.png"
const ManImg = styled.img`
width: 100%;
height: auto;
max-width: 500px;
`
const GridWrapper = styled(Grid)`
display: flex;
align-items: center;
`
const Section8_Team = () => {
  const theme = useTheme()
  return (
    <SectionWrapper p799="8rem 0 0" p599="10rem 0px 0" p="4rem 0 0">
      <Container maxWidth="xl" data-aos="fade-zoom-in" data-aos-easing="ease-in" data-aos-delay="500" data-aos-duration="500" data-aos-offset="0">
        <GridWrapper container>
          <Grid item xs={12} md={6}>
            <SectionHeading p="20px 0" m="0" align="left" color={theme.textSecondary} data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="500"
              data-aos-offset="0" >
              The Team
            </SectionHeading>
            <P p="0" m="0" color={theme.textSecondary} data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="500"
              data-aos-duration="500"
              data-aos-offset="0" >Our team consists of individuals from the community with a passion for creating innovative solutions in the cryptocurrency market. We are dedicated to providing our users with the best possible experience and are committed to the long-term success of the platform. If you're a member of the ArbFlow community willing to join us then feel free to link up with us via our Telegram and let us know how you can contribute.

            </P>
          </Grid>
          <Grid item xs={12} md={6} data-aos="fade-up"
            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
            data-aos-duration="500">
            <ManImg src={footerman} />
          </Grid>
        </GridWrapper>
      </Container>
    </SectionWrapper>
  )
};

export default Section8_Team;
